export default __webpack_public_path__ + "static/ICDMlogo-f504a0d1d64859808f49cd365336a492.jpg";